import type { Dict } from "./dict-shared";
import { HERO_DESC, CASE_CLIENTS } from "./dict-shared";

export const ptDict: Dict = {
  nav: {
    home: "Início", ia: "IA", integrations: "Integrações", cases: "Cases",
    pricing: "Planos", blog: "Blog", about: "Sobre", contact: "Contato",
    demoCta: "Solicitar demonstração", whatsapp: "WhatsApp",
    talkWhatsapp: "Falar no WhatsApp", openMenu: "Abrir menu",
    closeMenu: "Fechar menu", backHome: "Voltar para a home",
    features: "Funcionalidades",
  },
  footer: {
    tagline: "Chat omnichannel + CRM + IA em uma única plataforma. Centralize WhatsApp, Instagram, voz e e-mail e venda mais com automação inteligente.",
    productCol: "Produto", companyCol: "Empresa", legalCol: "Legal",
    rights: "Todos os direitos reservados.", address: "Endereço",
    privacy: "Política de privacidade", privacyNotice: "Aviso de privacidade", ombudsman: "Canal de Denúncias",
  },
  whatsappFab: { label: "Falar no WhatsApp" },
  mobileSticky: { demo: "Demonstração", whatsapp: "WhatsApp" },
  forms: {
    name: "Nome", namePh: "Seu nome", phone: "WhatsApp", phonePh: "(11) 99999-9999",
    company: "Empresa", companyPh: "Nome da empresa", email: "E-mail", emailPh: "voce@empresa.com",
    emailOptional: "E-mail (opcional)", segment: "Segmento", segmentPh: "Selecione um segmento",
    message: "Como podemos ajudar?", messagePh: "Conte um pouco sobre seu projeto, dor ou objetivo.",
    submit: "Enviar", submitting: "Enviando…", submitDemo: "Quero uma demonstração",
    requestDemo: "Solicitar demonstração", success: "Recebemos seu contato!",
    successDesc: "Abrindo WhatsApp com nosso time…", error: "Não foi possível enviar agora",
    errorDesc: "Tente novamente em alguns instantes ou fale por WhatsApp.",
    sentTitle: "Contato enviado", sentBody: "Estamos abrindo o WhatsApp para você continuar a conversa com nosso time.",
    sendAnother: "Enviar outro contato", requiredMark: "*",
    vNameMin: "Informe seu nome", vPhone: "Telefone inválido",
    vPhoneInvalid: "Use apenas números e símbolos de telefone",
    vCompany: "Informe a empresa", vSegment: "Selecione um segmento", vEmail: "E-mail inválido",
    waDefault: "Olá! Vim pelo site da Kentro e quero saber mais.",
    waContact: (c, s) => `Olá, vim pelo site da Kentro e quero agendar uma demonstração. Empresa: ${c} · Segmento: ${s}`,
  },
  contactBlock: {
    eyebrow: "Pronto para escalar?", titlePrefix: "Vamos transformar sua ",
    titleHighlight: "operação", titleSuffix: "",
    description: "Preencha o formulário ou fale com nosso time pelos canais ao lado. Respondemos em minutos durante o horário comercial.",
    address: "Endereço", attendance: "Atendimento", attendanceValue: "Brasil — 100% remoto",
  },
  contactPage: {
    titlePrefix: "Vamos ", titleHighlight: "conversar", titleSuffix: "",
    description: "Conte sobre sua operação e mostramos como a Kentro pode acelerar resultados.",
    eyebrow: "Solicite uma demonstração", metaTitle: "Contato — Kentro Sistemas",
    metaDesc: "Fale com a Kentro: agende uma demonstração, tire dúvidas ou peça uma proposta. Atendimento por WhatsApp, telefone e e-mail.",
  },
  finalCta: {
    titlePrefix: "Sua próxima venda perdida começa amanhã. ",
    titleHighlight: "A não ser que você organize isso hoje.", titleSuffix: "",
    description: "Agende uma demonstração de 20 minutos — sem custo e sem promessa de venda na call. Só mostramos como sua operação funciona daqui pra frente.",
    talkNow: "Falar no WhatsApp agora",
  },
  home: {
    metaTitle: "Kentro — Chat + CRM + IA: atenda e venda mais",
    metaDesc: "Transforme cada conversa em atendimento organizado, venda acompanhada e crescimento previsível. WhatsApp API Oficial, CRM e IA 24/7.",
  },
  common: { learnMore: "Conheça nossas soluções de IA", scheduleDemo: "Agendar demonstração", seeMore: "Ver mais", languageLabel: "Idioma" },

  hero: {
    badge: "Chat + CRM + IA · API Oficial do WhatsApp",
    titleA: "Transforme cada conversa em atendimento organizado, ",
    titleHighlight: "venda acompanhada e crescimento previsível.",
    descriptionHtml: HERO_DESC.pt,
    ctaPrimary: "Solicitar demonstração gratuita",
    ctaSecondary: "Calcular quanto perco hoje",
    social1: "+1.600 empresas", social2: "+14.670 agentes",
    social3: "Startup Destaque InovAtiva Brasil",
    mockupTitle: "Kentro · Inbox omnichannel", slaRisk: "SLA em risco",
    aiSuggested: "Resposta sugerida pela IA",
    metricConversions: "Conversões hoje", metricQueue: "Em fila", metricAi: "IA respondeu",
  },
  pillars: {
    badge: "Kentro Sistemas Inteligentes",
    titleA: "Kentro Sistemas Inteligentes — ",
    titleHighlight: "Chat + CRM + IA",
    description: "Os três pilares que organizam seu atendimento, aceleram suas vendas e escalam seu negócio sem aumentar a equipe.",
    chat: { title: "Chat", desc: "Omnichannel com WhatsApp API Oficial, Instagram, voz, e-mail e webchat em uma única caixa de entrada." },
    crm: { title: "CRM", desc: "Funil de vendas, histórico unificado do cliente e automações que organizam o time comercial." },
    ai: { title: "IA", desc: "Agentes treinados para o seu negócio que atendem, qualificam e vendem 24/7 com transbordo humano." },
    ctaPrimary: "Conheça as IAs da Kentro", ctaSecondary: "Testar IA grátis",
  },
  credibility: {
    aria: "Credibilidade Kentro",
    items: [
      "API Oficial do WhatsApp / Meta",
      "Startup Destaque InovAtiva Brasil 2023.2",
      "+1.600 empresas",
      "+14.670 agentes",
      "Kentro Academy para treinamento",
      "Conformidade com LGPD",
    ],
  },
  problem: {
    titleA: "O WhatsApp virou o coração da sua empresa. ",
    titleHighlight: "E também o seu maior buraco de vendas.",
    pains: [
      'Cliente manda "oi" às 9h, você responde 9h47 — e ele já comprou do concorrente.',
      "O cliente conta a história 3 vezes para 3 atendentes diferentes e desiste no meio do caminho.",
      "Seu número pessoal foi banido bem na hora que as vendas cresciam — e levou o histórico junto.",
      "Ninguém sabe de onde vêm os leads, quanto cada canal gera, nem por que o cliente sumiu.",
      "A equipe vive apagando incêndio e respondendo as mesmas perguntas, sem tempo para vender.",
      "A reclamação que vai cair amanhã no Reclame Aqui já começou hoje — com um cliente que se sentiu ignorado.",
    ],
    bottomLine: "Não é falta de esforço da sua equipe. É falta de um sistema que trate o WhatsApp como ele realmente é: ",
    bottomLineStrong: "assíncrono, com dono de conversa, contexto e ritmo.",
  },
  product: {
    titleA: "Tudo que sua operação precisa, em um só lugar — ",
    titleHighlight: "e o fim de pagar 5 softwares diferentes.",
    items: [
      { title: "Omnichannel Completo", text: "WhatsApp, Instagram, Facebook, Telegram, e-mail, SMS e voz numa única tela. O cliente nunca mais repete a história." },
      { title: "CRM e Funil de Vendas", text: "Você passa a saber de onde vem cada lead e em que etapa ele está. Follow-up automático, nada cai no esquecimento." },
      { title: "Automação de Cobrança", text: "Boleto, segunda via e negociação no WhatsApp. Clientes reduziram inadimplência em até 28%." },
      { title: "PABX Inteligente", text: "URA, gravações, filas e relatórios integrados ao CRM. Voz e texto na mesma história do cliente." },
      { title: "Gestão de Chamados (SLA)", text: 'Tickets roteados por habilidade, com prazo combinado. Acaba o "ninguém disse quando volta".' },
      { title: "Business Intelligence", text: "KPIs em tempo real. Você vê o problema antes do cliente reclamar." },
    ],
  },
  whatsappApi: {
    badge: "WhatsApp API Oficial",
    titleA: "Seu WhatsApp ",
    titleHighlight: "nunca mais será banido.",
    description: "Operar com número pessoal é uma bomba-relógio: ele cai justamente quando o movimento aumenta — e leva atendimentos, vendas e histórico junto.",
    items: [
      { title: "Estabilidade da API Oficial da Meta", text: "Sem risco de banimento, sem perder conversas." },
      { title: "Disparos em escala com segurança", text: "Campanhas e notificações sem queimar o número." },
      { title: "Profissionalismo", text: "Selo verificado e múltiplos atendentes no mesmo número." },
      { title: "Migração sem trocar de número", text: "Você mantém o contato que seus clientes já conhecem." },
    ],
    cta: "Migrar para a API Oficial",
  },
  segments: {
    titleA: "Feito para quem ",
    titleHighlight: "atende todos os dias.",
    description: "Cada setor tem uma dor diferente. A Kentro fala a língua do seu — veja o case e converse com a IA treinada para o seu segmento.",
    viewCase: "Ver case", test: "Testar",
    bridge: {
      badge: "IA por segmento",
      titleA: "Em vez de imaginar, ",
      titleHighlight: "converse com a IA do seu setor",
      description: "10 IAs treinadas por nicho — farmácia, clínica, provedor, faculdade, varejo e mais — prontas para você testar no WhatsApp em menos de 30 segundos.",
      cta: "Testar IAs grátis",
    },
  },
  realResults: {
    titleA: "Não prometemos. ",
    titleHighlight: "Comprovamos.",
    description: "Números reportados em cases e materiais internos. O desempenho pode variar conforme operação, implantação e maturidade do processo.",
    statLabels: [
      "empresas confiam na Kentro",
      "agentes operando todos os dias",
      "de crescimento ano a ano",
      "menos custo de atendimento",
      "menos inadimplência com cobrança automática",
    ],
    statNotes: [
      "Base ativa Kentro", "Base ativa Kentro", "Materiais comerciais Kentro",
      "Case ISP — contexto específico", "Case com cobrança automática",
    ],
    recognitionEyebrow: "Reconhecimento",
    recognitionText: "Startup Destaque — InovAtiva Brasil 2023.2",
  },
  lossCalc: {
    badge: "Calculadora de Perda",
    titleA: "Quanto sua empresa perde por mês com ",
    titleHighlight: "atendimento desorganizado?",
    description: "Responda 3 perguntas (volume de conversas/dia, ticket médio, % sem resposta) e veja a estimativa da sua perda — e quanto a Kentro recupera em 30 dias.",
    f1: "Conversas recebidas por dia",
    f2: "Ticket médio de venda",
    f3: "% de conversas sem resposta ou respondidas em atraso",
    suffixConvs: "conversas/dia",
    lossLabel: "Perda estimada por mês",
    lossFormula: "Estimativa baseada em: conversas/dia × 30 × % sem resposta × ticket × taxa média de conversão perdida (30%).",
    recoveryEyebrow: "Potencial de recuperação com a Kentro em 30 dias",
    recoveryPrefix: "até",
    recoveryHint: "Considerando aumento de taxa de resposta e priorização inteligente de filas.",
    cta: "Quero recuperar isso",
    disclaimer: "Estimativa para fins ilustrativos. Resultado real depende da sua operação.",
    calcMsgLabels: {
      calculator: "Calculadora de Perda",
      convsPerDay: "Conversas/dia",
      ticket: "Ticket",
      pctNoReply: "% sem resposta",
      monthlyLoss: "Perda estimada/mês",
    },
  },
  casesSection: {
    titleA: "Histórias de quem ",
    titleHighlight: "parou de perder cliente.",
    description: "Cases reais de clientes Kentro — clique em qualquer vídeo e ouça direto de quem usa.",
    featuredBadge: "⭐ Case em destaque",
    closeAria: "Fechar vídeo",
    iframeTitle: "Case de sucesso Kentro",
    playlistCta: "Ver playlist completa no YouTube",
    items: [
      { title: "Aumentou o contato com clientes e expandiu a base", client: CASE_CLIENTS[0].client, segment: "Farmácia" },
      { title: "Comunicação fluida com pacientes odontológicos", client: CASE_CLIENTS[1].client, segment: "Odontologia" },
      { title: "Agenda organizada e suporte ágil aos pacientes", client: CASE_CLIENTS[2].client, segment: "Saúde" },
      { title: "Melhorou o atendimento na clínica odontológica", client: CASE_CLIENTS[3].client, segment: "Odontologia" },
      { title: "Atendimento mais rápido e organizado", client: CASE_CLIENTS[4].client, segment: "Varejo" },
      { title: "Atendimento facilitado para tutores e pets", client: CASE_CLIENTS[5].client, segment: "Pet shop" },
      { title: "Kentro no dia a dia do atendimento pet", client: CASE_CLIENTS[6].client, segment: "Pet shop" },
    ],
  },
  faq: {
    titleA: "As dúvidas que te impedem de ",
    titleHighlight: "decidir hoje.",
    items: [
      { q: "Vou ter que trocar meu número?", a: "Não. A migração para a API Oficial mantém o número que seus clientes já conhecem." },
      { q: "Quanto tempo leva para implementar?", a: "A maioria das operações entra no ar em poucos dias, com onboarding guiado pela Kentro Academy." },
      { q: "Minha equipe vai conseguir usar?", a: "Sim. Treinamento por nível (agente, gerência, diretoria) incluído na Academy." },
      { q: "Integra com meu ERP/sistema?", a: "Sim — REST API, webhooks e SDKs com documentação clara." },
      { q: "E a segurança dos dados?", a: "Operação em conformidade com a LGPD." },
      { q: "A IA é boa mesmo?", a: "Agende a demo e veja a IA resolvendo um caso real, ao vivo." },
    ],
  },
};
